import { SourceStatusDrawerHeader } from './SourceStatusDrawerHeader';

interface StatusDrawerLayoutProps {
    title: string;
    isExpanded: boolean;
    allComplete: boolean;
    onToggleExpanded: () => void;
    onClose: () => void;
    children: React.ReactNode;
}

export function StatusDrawerLayout({
    title,
    isExpanded,
    allComplete,
    onToggleExpanded,
    onClose,
    children,
}: StatusDrawerLayoutProps) {
    return (
        <div className="fixed bottom-7 right-7 z-40 w-96">
            <div className="bg-grey-800 border border-grey-600 rounded-lg shadow-xl">
                <SourceStatusDrawerHeader
                    title={title}
                    isExpanded={isExpanded}
                    allComplete={allComplete}
                    onToggleExpanded={onToggleExpanded}
                    onClose={onClose}
                />

                {isExpanded && (
                    <div className="max-h-[320px] overflow-y-auto scrollbar-thin">
                        <div className="flex flex-col">{children}</div>
                    </div>
                )}
            </div>
        </div>
    );
}
